/* ============================================================
   Everlight Jewels — Global Loading System
   assets/elj-loading.js

   1. Lazy-image fade-in: watches every img[loading="lazy"] (plus any
      added later, e.g. Instagram tiles) and marks it faded-in once it
      has actually finished loading. CSS only fades images this script
      explicitly flags (.elj-fade-init) — if this file fails to load
      or errors, all images simply keep their normal full opacity.
   2. Product gallery variant-swap overlay: shows a brief static
      branded overlay over the media gallery whenever a variant-picker
      control changes, so the metal/variant image swap doesn't feel
      abrupt. Purely additive — never intercepts or blocks the actual
      swap logic already owned by the theme.
   3. UGC ring-spinner: clears the [data-elj-loader="ring"] spinner
      ring once that tile's image has loaded (handles Instagram tiles
      inserted dynamically after page load).
   ============================================================ */
(function () {
  "use strict";

  var LOGO_URL =
    "https://cdn.shopify.com/s/files/1/0579/1285/2550/files/Everlight_Jewels_logo_Final-08.svg?v=1788340616";

  /* ---------- 1 + 3. Lazy image fade-in / ring-spinner clear ---------- */

  function markLoaded(img) {
    img.classList.add("elj-loaded");
    var ringHost = img.closest('[data-elj-loader="ring"]');
    if (ringHost) ringHost.classList.add("elj-loaded");
  }

  function watch(img) {
    if (img.dataset.eljWatched) return;
    img.dataset.eljWatched = "1";

    if (img.complete && img.naturalWidth > 0) {
      // Already loaded (e.g. served from cache) — skip the fade, just
      // clear any ring spinner, and never set opacity:0 on it.
      markLoaded(img);
      return;
    }

    img.classList.add("elj-fade-init");

    img.addEventListener("load", function () {
      markLoaded(img);
    });
    img.addEventListener("error", function () {
      // Never leave a broken image invisible.
      markLoaded(img);
    });
  }

  function scan(root) {
    var scope = root || document;
    var imgs = scope.querySelectorAll
      ? scope.querySelectorAll('img[loading="lazy"]')
      : [];
    for (var i = 0; i < imgs.length; i++) watch(imgs[i]);
    if (scope.tagName === "IMG" && scope.getAttribute("loading") === "lazy") {
      watch(scope);
    }
  }

  scan(document);

  if ("MutationObserver" in window) {
    var mo = new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var added = mutations[m].addedNodes;
        for (var n = 0; n < added.length; n++) {
          var node = added[n];
          if (node.nodeType !== 1) continue;
          if (node.tagName === "IMG") {
            watch(node);
          } else if (node.querySelectorAll) {
            scan(node);
          }
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---------- 2. Product gallery variant-swap overlay ---------- */

  function ensureGalleryOverlay(gallery) {
    var overlay = gallery.querySelector(":scope > .elj-gallery-loading");
    if (overlay) return overlay;
    overlay = document.createElement("div");
    overlay.className = "elj-gallery-loading";
    var img = document.createElement("img");
    img.src = LOGO_URL;
    img.alt = "";
    img.setAttribute("aria-hidden", "true");
    overlay.appendChild(img);
    gallery.appendChild(overlay);
    return overlay;
  }

  function showGalleryOverlay(gallery) {
    var overlay = ensureGalleryOverlay(gallery);
    overlay.classList.add("is-active");
    window.clearTimeout(gallery._eljOverlayTimer);
    gallery._eljOverlayTimer = window.setTimeout(function () {
      overlay.classList.remove("is-active");
    }, 700);
  }

  document.addEventListener(
    "change",
    function (e) {
      var target = e.target;
      if (!target || !target.closest) return;
      if (!target.closest("variant-picker")) return;
      var isOptionControl =
        (target.tagName === "INPUT" && target.type === "radio") ||
        target.tagName === "SELECT";
      if (!isOptionControl) return;

      var productWrapper =
        target.closest("[data-product-id]") || document;
      var gallery = productWrapper.querySelector(
        "media-gallery, .m-product-media-gallery"
      );
      if (gallery) showGalleryOverlay(gallery);
    },
    true
  );
})();
